// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// App-Navigation unten: Training sitzt erhoben in der Mitte (wichtigste
// Aktion), bei laufender Session zeigt ein Ring den Übungs-Fortschritt.
import { useEffect, useState } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { IconHantel, IconHuette, IconVerlauf, IconSpross, IconPlan } from "./icons"
import { loadSession, onSession, sessionProgress } from "@/lib/session"

const LINKS = [
  { to: "/start", label: "Start", Icon: IconHuette },
  { to: "/verlauf", label: "Verlauf", Icon: IconVerlauf },
]
const RECHTS = [
  { to: "/fortschritt", label: "Fortschritt", Icon: IconSpross },
  { to: "/plan", label: "Plan", Icon: IconPlan },
]

const UMFANG = 2 * Math.PI * 27 // Ring r=27 im 60er-viewBox

function Item({ to, label, Icon, auchAktiv }: {
  to: string
  label: string
  Icon: (p: { size?: number }) => React.JSX.Element
  auchAktiv?: boolean
}) {
  return (
    <NavLink
      key={to}
      to={to}
      className={({ isActive }) => (isActive || auchAktiv ? "bn-item aktiv" : "bn-item")}
    >
      <span className="bn-icon"><Icon /></span>
      <span className="bn-label">{label}</span>
    </NavLink>
  )
}

export default function BottomNav() {
  const { pathname } = useLocation()
  const [aktiv, setAktiv] = useState(false)
  const [prog, setProg] = useState(0)

  useEffect(() => {
    let alive = true
    void loadSession().then((s) => {
      if (!alive) return
      setAktiv(s !== null)
      setProg(sessionProgress(s))
    })
    const off = onSession((s) => {
      setAktiv(s !== null)
      setProg(sessionProgress(s))
    })
    return () => { alive = false; off() }
  }, [])

  return (
    <nav className="bottomnav" aria-label="Bereiche">
      {/* „Nachtragen" (/log) hat keinen eigenen Knopf mehr — der Start-Tab
          bleibt markiert, damit niemand rätselt, wo er gelandet ist */}
      {LINKS.map((l) => <Item key={l.to} {...l} auchAktiv={l.to === "/start" && pathname === "/log"} />)}
      <NavLink to="/training" className="bn-item bn-center">
        <span className="bn-cbtn">
          {aktiv && (
            <svg className="bn-ring" viewBox="0 0 60 60" aria-hidden="true">
              <circle className="bn-ring-track" cx="30" cy="30" r="27" />
              <circle
                className="bn-ring-prog"
                cx="30" cy="30" r="27"
                transform="rotate(-90 30 30)"
                style={{ strokeDashoffset: UMFANG * (1 - prog) }}
              />
            </svg>
          )}
          <IconHantel size={26} />
        </span>
        <span className="bn-label">Training</span>
      </NavLink>
      {/* Die Bibliothek (/plaene) gehört zum Bereich „Plan" — Tab bleibt markiert */}
      {RECHTS.map((l) => <Item key={l.to} {...l} auchAktiv={l.to === "/plan" && pathname.startsWith("/plaene")} />)}
    </nav>
  )
}
